import styled from 'styled-components';

export const AlertEdit = styled.div`
  width: 100%;
`;
